export default __webpack_public_path__ + "static/media/p28.4121af01.jpg";